/**
 * Período usado no mapa/rastreamento: prioriza execução real informada pelo operador.
 */
export function hasExecutedPeriod(obs) {
  return Boolean(
    obs &&
      obs.confirmed &&
      obs.executed_start_date &&
      obs.executed_end_date
  );
}

export function getObservationMapPeriod(obs) {
  if (hasExecutedPeriod(obs)) {
    return {
      start: obs.executed_start_date,
      end: obs.executed_end_date,
      source: "executed",
    };
  }

  return {
    start: obs.start_date,
    end: obs.end_date,
    source: "scheduled",
  };
}

export function hasScheduleExecutionDivergence(obs) {
  if (!hasExecutedPeriod(obs)) return false;

  const schedStart = new Date(obs.start_date).getTime();
  const schedEnd = new Date(obs.end_date).getTime();
  const execStart = new Date(obs.executed_start_date).getTime();
  const execEnd = new Date(obs.executed_end_date).getTime();

  return schedStart !== execStart || schedEnd !== execEnd;
}

export function observationContainsMapPoint(obs, dateStr) {
  if (!dateStr) return false;

  const target = new Date(dateStr).getTime();
  const { start, end } = getObservationMapPeriod(obs);

  return (
    target >= new Date(start).getTime() && target <= new Date(end).getTime()
  );
}

export function formatObservationDateTime(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
